import type { CSSProperties, ReactNode } from "react";

type BaseAlign = "flex-start" | "center" | "flex-end";
type Justify = BaseAlign | "space-between" | "space-around" | "space-evenly";
type HorizontalAlign = BaseAlign;
type VerticalAlign = BaseAlign | "baseline";

interface ContainerProps {
	box?: CSSProperties;
	className?: string;
	children: ReactNode;
}

interface BaseProps<AlignType> extends ContainerProps {
	alignItems?: AlignType;
	justifyContent?: Justify;
}

interface FlexBoxProps extends BaseProps<VerticalAlign> {
	direction: "column" | "row";
}

type VerticalProps = BaseProps<HorizontalAlign>;
type HorizontalProps = BaseProps<VerticalAlign>;
type CenterProps = ContainerProps;

/**
 * @deprecated Use `SG` or native HTML & CSS.
 */
const FlexBox = ({ box, className, direction, alignItems, justifyContent, children }: FlexBoxProps) => (
	<div className={className} style={{ display: "flex", flexDirection: direction, alignItems, justifyContent, ...box }}>
		{children}
	</div>
);

/**
 * @deprecated Use `SG` or native HTML & CSS.
 */
const Vertical = (props: VerticalProps) => (
	<FlexBox {...props} direction="column">
		{props.children}
	</FlexBox>
);

/**
 * @deprecated Use `SG` or native HTML & CSS.
 */

const Horizontal = (props: HorizontalProps) => (
	<FlexBox {...props} direction="row">
		{props.children}
	</FlexBox>
);

/**
 * @deprecated Use `SG` or native HTML & CSS.
 */
const Center = (props: CenterProps) => (
	<FlexBox {...props} direction="row" alignItems="center" justifyContent="center">
		{props.children}
	</FlexBox>
);

export default FlexBox;
export { Center, Horizontal, Vertical };
